export default {
    root: {
        class: [
            '[&>[data-pc-name=button]]:m-0', // Removes margin to ensure no gaps
            '[&>[data-toggle-button][data-pc-name=button]]:!px-3', // Applies padding to toggle buttons
            '[&>[data-pc-name=button]]:border', // Adds border to all sides of the button
            '[&>[data-pc-name=button]:nth-last-child(n+2)]:rounded-tr-none', // Removes top-right corner radius for non-last buttons
            '[&>[data-pc-name=button]:nth-last-child(n+2)]:rounded-br-none', // Removes bottom-right corner radius for non-last buttons
            '[&>[data-pc-name=button]:nth-child(n+2)]:rounded-tl-none', // Removes top-left corner radius for non-first buttons
            '[&>[data-pc-name=button]:nth-child(n+2)]:rounded-bl-none', // Removes bottom-left corner radius for non-first buttons
            '[&>[data-pc-name=button]:focus]:z-10', // Ensures focused button stays above adjacent buttons for proper border rendering
            '[&>[data-pc-name=button]:not(:first-child)]:border-l-0', // Removes the left border for all buttons except the first
            '[&>[data-pc-name=button]:nth-child(n+2)]:border-l', // Ensure that buttons after the first have a left border

            // Give the active secondary button a higher z-index to ensure its borders are above others
            '[&>[data-pc-name=button][data-p-severity="secondary"]]:z-20',

            // Moves the non-active buttons by 1px to avoid double borders
            '[&>[data-pc-name=button]:not([data-p-severity="secondary"])]:-ml-[1px]',

            // Add `border-primary-700` only to dividers between buttons that are not toggle and not secondary
            '[&>[data-pc-name=button]:not([data-toggle-button]):not([data-outlined-button]):not([data-p-severity="secondary"]):nth-child(n+2)]:border-l-primary-400'
        ]
    }
};
